module.exports = __webpack_public_path__ + "img/NL.79c033ab.svg";